import { axiosInstance as axios, handleAxiosErrors } from '../_utils';
import { convertCreditCardListingToAReadableFormat } from '../selectors/converterSelector';
import config from '../store/_config';
import { buildCreateCreditCardData } from '../selectors/creditCardSelector';
import { buildAddressParams } from '../selectors/addressSelector';
// import { createAlert } from "../dom/window";

export const toggleLoading = (key, value) => {
    return {
        type: 'TOGGLE_CREDIT_CARD_LOADING',
        key: key,
        value: value,
    };
};
export const toggleRowLoading = (key, identifier, value) => {
    return {
        type: 'TOGGLE_CREDIT_CARD_ROW_LOADING',
        key: key,
        identifier: identifier,
        value: value,
    };
};
export const replaceCreditCardList = (value) => {
    return {
        type: 'REPLACE_CREDIT_CARD_LIST',
        value: value,
    };
};
export const requestCreditCards = (params) => {
    return (dispatch, getState) => {
        // const state = getState();

        return;

        let { url, query } = config.creditCard.listing;
        const showLoading =
            typeof params != 'undefined' &&
            typeof params.withLoading != 'undefined'
                ? params.withLoading
                : true;

        if (showLoading) {
            dispatch(toggleLoading('list', true));
        }

        return axios
            .get(url, {
                withCredentials: true,
                params: {
                    query: query,
                },
            })
            .then((response) => {
                const products = convertCreditCardListingToAReadableFormat(
                    response.data.data.readCreditCards
                );

                // wait for async requests
                Promise.all([dispatch(replaceCreditCardList(products))]).then(
                    () => {
                        dispatch(toggleLoading('list', false));
                    }
                );
            })
            .catch((error) => handleAxiosErrors(error));
    };
};
export const makeDefault = (identifier) => {
    return (dispatch, getState) => {
        const state = getState();

        let { url, query } = config.creditCard.makeDefault;
        let data = {
            id: query,
            variables: {
                Input: {
                    ID: identifier,
                    IsDefault: true,
                },
            },
        };

        dispatch(toggleRowLoading('IsDefault', identifier, true));

        return axios
            .post(url, data, {
                withCredentials: true,
            })
            .then((response) => {
                Promise.all([
                    dispatch(requestCreditCards({ withLoading: false })),
                ]).then(() => {
                    dispatch(toggleRowLoading('IsDefault', identifier, false));
                });
            })
            .catch((error) => {
                dispatch(toggleRowLoading('IsDefault', identifier, false));
                handleAxiosErrors(error);
            });
    };
};
export const removeCreditCard = (identifier) => {
    return (dispatch, getState) => {
        let { url, query } = config.creditCard.delete;
        let data = {
            id: query,
            variables: {
                ID: identifier,
            },
        };

        dispatch(toggleRowLoading('IsDelete', identifier, true));

        return axios
            .post(url, data, {
                withCredentials: true,
            })
            .then((response) => {
                Promise.all([
                    dispatch(requestCreditCards({ withLoading: false })),
                ]).then(() => {
                    dispatch(toggleRowLoading('IsDelete', identifier, false));
                });
            })
            .catch((error) => {
                dispatch(toggleRowLoading('IsDelete', identifier, false));
                handleAxiosErrors(error);
            });
    };
};
export const submitCreditCard = (formData, callback) => {
    return (dispatch, getState) => {
        let { url, query } = config.creditCard.create;
        let data = {
            id: query,
            variables: {
                Input: buildCreateCreditCardData(formData),
            },
        };

        dispatch(toggleLoading('form', true));

        return axios
            .post(url, data, {
                withCredentials: true,
            })
            .then((response) => {
                // Flush Form
                dispatch(toggleLoading('form', false));

                // Re-request category
                dispatch(requestCreditCards());

                if (
                    typeof callback != 'undefined' &&
                    typeof callback.success != 'undefined'
                ) {
                    callback.success();
                }
            })
            .catch((error) => {
                dispatch(toggleLoading('form', false));
                handleAxiosErrors(error);
            });
    };
};
export const axiosCreateCreditCard = (formData) => {
    let { url, query } = config.creditCard.create;
    let data = {
        id: query,
        variables: {
            Input: buildCreateCreditCardData(formData),
        },
    };

    return axios.post(url, data, {
        withCredentials: true,
    });
};
export const axiosCreateCreditCardAddress = (formData) => {
    let { url, query } = config.creditCard.createAddress;
    let data = {
        id: query,
        variables: {
            Input: buildAddressParams(formData),
        },
    };

    return axios.post(url, data, {
        withCredentials: true,
    });
};
export const axiosRequestCreditCards = () => {
    let { url, query } = config.creditCard.listing;

    return axios.get(url, {
        withCredentials: true,
        params: {
            query: query,
        },
    });
};
export const axiosRequestDefaultCreditCardID = () => {
    let { url, query } = config.creditCard.defaultCreditCardID;

    return axios.get(url, {
        withCredentials: true,
        params: {
            query: query,
        },
    });
};
export const axiosDeleteCreditCard = (ID) => {
    let { url, query } = config.creditCard.delete;

    let data = {
        id: query,
        variables: {
            ID: Number(ID),
        },
    };

    return axios.post(url, data, {
        withCredentials: true,
    });
};
